import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/ApiService';
import { useAuth } from '../account/AuthContext';

const OrderSuccessPage = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    // Zmiana: używamy state zamiast stałej
    const [orderId, setOrderId] = useState(localStorage.getItem('pending_order_id'));

    useEffect(() => {
        document.title = "Auto Wycena Druku 3D - Geometry Hustlers";
    }, []);

    useEffect(() => {
        if (!orderId) {
            navigate('/quote', { replace: true });
        }
    }, [orderId, navigate]);

    const [status, setStatus] = useState('checking');
    const [orderData, setOrderData] = useState(null);
    const intervalActive = React.useRef(true);

    const checkPaymentStatus = async (orderId) => {
        if (!intervalActive.current) return;
        try {
            const response = await ApiService.checkPaymentStatus(orderId);

            setOrderData(response);

            if (response.payment_status === 'paid') {
                intervalActive.current = false;
                setStatus('paid');
                //localStorage.removeItem('pending_order_id');
            } else if (response.payment_status === 'pending') {
                setStatus('pending');
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        }
    };


    useEffect(() => {
        if (!orderId) return;
        intervalActive.current = true;
        checkPaymentStatus(orderId);

        const interval = setInterval(() => {
            if (intervalActive.current) {
                checkPaymentStatus(orderId);
            }
        }, 3000);

        // Po 30s timeout
        const timeout = setTimeout(() => {
            intervalActive.current = false;
            clearInterval(interval);

            setStatus(prevStatus => {
                if (prevStatus === 'checking') {
                    return 'pending';
                }
                return prevStatus;
            });
        }, 30000);

        return () => {
            intervalActive.current = false;
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [orderId]);

    if (!orderId) {
        return null;
    }

    const handleContinue = () => {
        // Czyść tylko klucze związane z order-success
        localStorage.removeItem('pending_order_id');
        navigate('/quote');
    };

    const handleGoToAccount = () => {
        // Czyść tylko klucze związane z order-success
        localStorage.removeItem('pending_order_id');
        navigate('/account');
    };

    return (
        <div className="app">
        <div style={{
            maxWidth: '600px',
            margin: '80px auto',
            padding: '40px',
            textAlign: 'center',
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
        {status === 'checking' && (
            <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <h2>Sprawdzamy status płatności...</h2>
            <p style={{ color: '#666' }}>Proszę czekać, to może chwilę potrwać.</p>
            </>
        )}

        {status === 'paid' && (
            <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
            <h2 style={{ color: '#28a745' }}>Płatność zakończona sukcesem!</h2>
            <p style={{ fontSize: '18px', marginTop: '20px' }}>
            Zamówienie <strong>#{orderData?.id}</strong> zostało opłacone.
            </p>
            <p style={{ color: '#666', marginTop: '10px' }}>
            Wkrótce otrzymasz potwierdzenie na e-mail.
            </p>
            {isAuthenticated ? (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleGoToAccount}>
                Przejdź do moich zamówień
                </button>
            ) : (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleContinue}>
                Kontynuuj
                </button>
            )}
            </>
        )}

        {status === 'pending' && (
            <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <h2 style={{ color: '#ffc107' }}>Przetwarzamy Twoją płatność</h2>
            <p style={{ fontSize: '18px', marginTop: '20px' }}>
            Zamówienie <strong>#{orderData?.id}</strong> jest w trakcie realizacji.
            </p>
            <p style={{ color: '#666', marginTop: '10px' }}>
            Otrzymasz potwierdzenie na e-mail, gdy płatność zostanie zaksięgowana.
            </p>
            {isAuthenticated ? (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleGoToAccount}>
                Przejdź do moich zamówień
                </button>
            ) : (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleContinue}>
                Kontynuuj
                </button>
            )}
            </>
        )}

        {status === 'error' && (
            <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
            <h2 style={{ color: '#dc3545' }}>Wystąpił problem z płatnością</h2>
            <p style={{ fontSize: '18px', marginTop: '20px' }}>
            Zamówienie <strong>#{orderData?.id}</strong> nie zostało opłacone.
            </p>
            <p style={{ color: '#666', marginTop: '10px' }}>
            Możesz spróbować ponownie z poziomu swoich zamówień.
            </p>
            {isAuthenticated ? (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleGoToAccount}>
                Przejdź do moich zamówień
                </button>
            ) : (
                <button className="btn" style={{ marginTop: '30px' }} onClick={handleContinue}>
                Kontynuuj
                </button>
            )}
            </>
        )}

        </div>
        </div>
    );
};




export default OrderSuccessPage;
